// src/pages/Auth/index.jsx
import React, { useState } from 'react';
import { Card, Form, Input, Button, Checkbox, Divider, Typography, message } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';

const Auth = ({ onLogin, onRegister, loggedInUser }) => {
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // 添加导航功能

  const handleLogin = (values) => {
    setLoading(true);
    setTimeout(() => {
      onLogin({ name: values.username });
      message.success('登录成功！');
      setLoading(false);
      navigate('/'); // 登录成功后跳转到首页
    }, 1000);
  };

  const handleRegister = (values) => {
    setLoading(true);
    setTimeout(() => {
      onRegister({ name: values.username });
      message.success('注册成功！');
      setIsLoginMode(true);
      setLoading(false);
      navigate('/'); // 注册成功后跳转到首页
    }, 1000);
  };

  // 表单验证规则
  const usernameRules = [
    { required: true, message: '请输入用户名！' },
    { min: 3, message: '用户名至少3个字符！' },
    { max: 20, message: '用户名最多20个字符！' },
    { pattern: /^[a-zA-Z0-9_]+$/, message: '用户名只能包含字母、数字和下划线！' }
  ];

  const emailRules = [
    { required: true, message: '请输入邮箱！' },
    { type: 'email', message: '请输入有效的邮箱地址！' }
  ];

  const passwordRules = [
    { required: true, message: '请输入密码！' },
    { min: 6, message: '密码至少6个字符！' },
    { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, message: '密码至少包含一个大写字母、一个小写字母和一个数字！' }
  ];

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppHeader />

      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px 0'
      }}>
        <Card title={isLoginMode ? "用户登录" : "用户注册"} style={{ width: 400 }}>
          <Form
            name="auth_form"
            initialValues={{ remember: true }}
            onFinish={isLoginMode ? handleLogin : handleRegister}
          >
            <Form.Item
              name="username"
              rules={usernameRules}
            >
              <Input prefix={<UserOutlined />} placeholder="用户名" />
            </Form.Item>

            {!isLoginMode && (
              <Form.Item
                name="email"
                rules={emailRules}
              >
                <Input prefix={<MailOutlined />} placeholder="邮箱" />
              </Form.Item>
            )}

            <Form.Item
              name="password"
              rules={passwordRules}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="密码" />
            </Form.Item>

            {isLoginMode && (
              <Form.Item name="remember" valuePropName="checked">
                <Checkbox>记住我</Checkbox>
              </Form.Item>
            )}

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                loading={loading}
              >
                {isLoginMode ? '登录' : '注册'}
              </Button>
            </Form.Item>
          </Form>

          <Divider>{isLoginMode ? '还没有账号？' : '已有账号？'}</Divider>
          <Typography.Link
            block
            style={{ textAlign: 'center' }}
            onClick={() => setIsLoginMode(!isLoginMode)}
          >
            {isLoginMode ? '点击注册' : '点击登录'}
          </Typography.Link>
        </Card>
      </div>

      <AppFooter />
    </div>
  );
};

export default Auth;